(ns common.db.coeffects.sessionstorage
  (:require [clojure.spec.alpha :as spec]
            [common.sessionstorage :as sessionstorage]
            [re-frame.core :as rf]))

(defn sessionstorage
  "Read from session storage

   Example:

   ```clojure
   (rf/reg-event-fx :sample-event
    [(rf/inject-cofx :sessionstorage \"something-stored-in-ss\")]
    (fn [{:keys [sessionstorage]}]
      ...))

   (rf/reg-event-fx :sample-event
    [(rf/inject-cofx :sessionstorage [\"something-stored-in-ss\" \"other-stored-in-ss\"] )]
    (fn [{:keys [sessionstorage]}]
      ...))
   ```"
  [cofx ks]
  {:pre [(spec/assert (spec/or :set set? :seq sequential? :string string?) ks)]}
  (let [collected-values (reduce (fn [cofx* k]
                                   (assoc cofx* (keyword :sessionstorage k) (sessionstorage/get k)))
                                 cofx
                                 (if ((some-fn sequential? set?) ks) ks [ks]))]
    collected-values))

(rf/reg-cofx :sessionstorage sessionstorage)
